import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Works from '@/components/Works';
import About from '@/components/About';
import Team from '@/components/Team';
import Contacts from '@/components/Contacts';
import store from './store.js';

Vue.use(Router);

const router = new Router({
  routes: [
      {
          path: '/',
          name: 'Home',
          component: Home
      },
      {
          path: '/works',
          name: 'Works',
          component: Works,
          props: true
      },
      {
          path: '/about',
          name: 'About',
          component: About,
      },
      /*{
          path: '/team',
          name: 'Team',
          component: Team,
      },*/
      {
          path: '/contacts',
          name: 'Contacts',
          component: Contacts
      },
      {
          path: '*',
          redirect: {name: 'Home'}
      }
  ]
});

router.beforeEach((to, from, next) => {
  if (!from.name) {
    next();
  } else {
    store.commit('loaderON');

    setTimeout(function () {
      next();
    }, 400);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js